import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0D1729] text-white flex items-center justify-center p-6">
      <div className="max-w-xl w-full hairline bg-[#152138] p-10 lg:p-16" data-testid="payment-cancel-panel">
        <div className="mono-label mb-6">§ RETAINER · CANCELLED</div>
        <h1 className="font-serif-display text-4xl">No retainer captured.</h1>
        <p className="text-slate-400 mt-4 text-sm">Your inquiry remains on file. You may resume retainer at any time.</p>
        <div className="mt-10 flex gap-4">
          <Link to="/#inquiry" className="btn-primary" data-testid="retry-payment-link">Resume Retainer</Link>
          <Link to="/" className="btn-secondary" data-testid="cancel-back-home">← Return to Index</Link>
        </div>
      </div>
    </div>
  );
}
